module.exports = __webpack_public_path__ + "img/table-icon-wpp-disabled.45442dec.png";